import React, { memo } from 'react';
import { ROOMS } from '../../config';

const BookingFormFields = memo(({
  formData,
  handleChange,
  errors = {},
  t,
  isUserDisabled = false
}) => {
  const today = new Date().toISOString().split('T')[0];

  return (
    <>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="date">{t('date')} *</label>
          <input
            type="date"
            id="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            min={today}
            required
          />
          {errors.date && <div className="error">{errors.date}</div>}
        </div>

        <div className="form-group">
          <label htmlFor="room">{t('room')} *</label>
          <select
            id="room"
            name="room"
            value={formData.room}
            onChange={handleChange}
            required
          >
            <option value="" disabled>{t('select_room')}</option>
            {ROOMS.map(room => (
              <option key={room} value={room}>{room}</option>
            ))}
          </select>
          {errors.room && <div className="error">{errors.room}</div>}
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="start_time">{t('start_time')} *</label>
          <input
            type="time"
            id="start_time"
            name="start_time"
            value={formData.start_time}
            onChange={handleChange}
            required
          />
          {errors.start_time && <div className="error">{errors.start_time}</div>}
        </div>

        <div className="form-group">
          <label htmlFor="end_time">{t('end_time')} *</label>
          <input
            type="time"
            id="end_time"
            name="end_time"
            value={formData.end_time}
            onChange={handleChange}
            required
          />
          {errors.end_time && <div className="error">{errors.end_time}</div>}
        </div>
      </div>

      <div className="form-row" style={{ gridTemplateColumns: '1fr 2fr' }}>
        <div className="form-group">
          <label htmlFor="runggun">{t('runggun')} *</label>
          <select
            id="runggun"
            name="runggun"
            value={formData.runggun}
            onChange={handleChange}
            required
          >
            <option value="" disabled>{t('select_runggun')}</option>
            <option value="Bogor">Bogor</option>
            <option value="Bogor Barat">Bogor Barat</option>
          </select>
          {errors.runggun && <div className="error">{errors.runggun}</div>}
        </div>

        <div className="form-group">
          <label htmlFor="user">{t('requester_name')} *</label>
          <input
            type="text"
            id="user"
            name="user"
            value={formData.user}
            onChange={handleChange}
            maxLength={100}
            required
            disabled={isUserDisabled}
          />
          {errors.user && <div className="error">{errors.user}</div>}
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="event_description">{t('event_description')} *</label>
        <textarea
          id="event_description"
          name="event_description"
          value={formData.event_description}
          onChange={handleChange}
          maxLength={500}
          placeholder={t('explain_event')}
          required
        />
        {errors.event_description && <div className="error">{errors.event_description}</div>}
      </div>
    </>
  );
});

export default BookingFormFields;
